"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var Option = exports.Option = /*#__PURE__*/_react["default"].memo(function (props) {
  var data = props.data,
    innerProps = props.innerProps,
    selectOption = props.selectOption;
  var custom = data.custom,
    CustomComponent = data.CustomComponent;
  return custom && CustomComponent ? CustomComponent && /*#__PURE__*/_react["default"].createElement(CustomComponent, (0, _extends2["default"])({
    selectOption: selectOption
  }, innerProps)) : /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props);
});
Option.displayName = 'Option';